import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles/index';

const styles = () => ({
	sectionHeader : {
		margin : '40px 0px 5px 0px',
		textAlign : 'left',
		textTransform : 'uppercase',
		fontSize : 14,
		color : '#777',
		fontWeight : 900,
		letterSpacing : 2,
	},
});

class FMPSectionHeader extends Component {
	render () {
		const {label, classes, isTop} = this.props;
		const style = (isTop) ? { marginTop : 0} : {};
		return (
			<div className={classes.sectionHeader} style={style}>{label}</div>
		);
	}
}

FMPSectionHeader.propTypes = {
	label: PropTypes.string.isRequired,
	classes: PropTypes.object.isRequired,
	isTop : PropTypes.bool,
};

export default _.flow([
	withStyles(styles),
])(FMPSectionHeader);
